export default __webpack_public_path__ + "assets/srilanka-flag.png";